module.exports = __webpack_public_path__ + "img/logo-ico.e9e55392.png";